'use client'

import { lazy, Suspense } from 'react'

const isDev = process.env.NODE_ENV === 'development'

const TanStackDevtools = lazy(() =>
  isDev
    ? import('@tanstack/react-devtools').then((m) => ({
        default: m.TanStackDevtools
      }))
    : Promise.resolve({ default: () => null })
)

const ReactQueryDevtoolsPanel = lazy(() =>
  isDev
    ? import('@tanstack/react-query-devtools').then((m) => ({
        default: m.ReactQueryDevtoolsPanel
      }))
    : Promise.resolve({ default: () => null })
)

const FormDevtoolsPanel = lazy(() =>
  isDev
    ? import('@tanstack/react-form-devtools').then((m) => ({
        default: m.FormDevtoolsPanel
      }))
    : Promise.resolve({ default: () => <></> })
)

export function TanstackDevtools() {
  if (!isDev) {
    return null
  }

  return (
    <Suspense fallback={null}>
      <TanStackDevtools
        plugins={[
          {
            defaultOpen: true,
            name: 'TanStack Query',
            render: <ReactQueryDevtoolsPanel />
          },
          {
            defaultOpen: false,
            name: 'TanStack Form',
            render: <FormDevtoolsPanel />
          }
        ]}
      />
    </Suspense>
  )
}
